import { jsx as c, jsxs as H, Fragment as xe } from "react/jsx-runtime";
import { c as he } from "./chunks/index.rKuIKazb.js";
import B, { createContext as se, useContext as le, useRef as Ie, useState as re, useEffect as fe, useMemo as Oe, useCallback as Ge } from "react";
import { Icon as De } from "./icon.js";
import { Spinner as Je } from "./spinner.js";
import { Theme as Qe } from "./theme.js";
import { Flex as Ne } from "./flex.js";
import { u as Xe } from "./chunks/35RDKJF6.CV6DV0ek.js";
import { r as Ye, s as Ze, t as et, v as Ae, g as tt, C as ot, w as rt, a as nt, c as lt, b as st, x as Ve, e as at, d as it, u as ct, y as ut, k as dt, l as mt, f as pt, q as vt, L as ft } from "./chunks/list-box-item.Brhznzvl.js";
import { k as O, l as D, g as E, h as f, K as Se, j as N, z as A, m as q, q as W, J as ht, O as Te, A as St, F as G, c as bt, _ as gt, a as ee, d as I, b as R, u as Ct, v as z, x as be, y as yt, D as wt, w as ge, P as Pt, Q as xt, G as Le, H as _t, I as Et, R as kt, L as It } from "./chunks/7FZLUSKW.7Pws8uOI.js";
import { m as Ot, o as Dt, t as Nt, s as te, a as pe, b as At, c as Vt, u as Tt, d as _e, i as Lt, e as Kt, f as jt } from "./chunks/YLXVVG22.DAM5w7Mj.js";
import { a as Mt } from "./chunks/typed.J9F93ogK.js";
import { F as Rt } from "./chunks/field.CyPGgOAN.js";
import './assets/select.css';var zt = se(!1), $t = "span", Ft = /* @__PURE__ */ c(
  "svg",
  {
    display: "block",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    children: /* @__PURE__ */ c("polyline", { points: "4,8 7,12 12,4" })
  }
);
function Ht(o) {
  return o.checked ? o.children || Ft : typeof o.children == "function" ? o.children : null;
}
var Ke = O(
  function(n) {
    var r = n, { store: e, checked: t } = r, l = D(r, ["store", "checked"]);
    const s = le(zt);
    t = t ?? s;
    const u = Ht({ checked: t, children: l.children });
    return l = E(f({
      "aria-hidden": !0
    }, l), {
      children: u,
      style: f({
        width: "1em",
        height: "1em",
        pointerEvents: "none"
      }, l.style)
    }), Se(l);
  }
);
N(function(n) {
  const r = Ke(n);
  return A($t, r);
});
var Bt = "div", T = "";
function ve() {
  T = "";
}
function qt(o) {
  const n = o.target;
  return n && ht(n) ? !1 : o.key === " " && T.length ? !0 : o.key.length === 1 && !o.ctrlKey && !o.altKey && !o.metaKey && /^[\p{Letter}\p{Number}]$/u.test(o.key);
}
function Wt(o, n) {
  if (Te(o)) return !0;
  const r = o.target;
  return r ? n.some((t) => t.element === r) : !1;
}
function Ut(o) {
  return o.filter((n) => !n.disabled);
}
function ne(o, n) {
  var r;
  const e = ((r = o.element) == null ? void 0 : r.textContent) || o.children || // The composite item object itself doesn't include a value property, but
  // other components like Select do. Since CompositeTypeahead is a generic
  // component that can be used with those as well, we also consider the value
  // property as a fallback for the typeahead text content.
  "value" in o && o.value;
  return e ? St(e).trim().toLowerCase().startsWith(n.toLowerCase()) : !1;
}
function Gt(o, n, r) {
  if (!r) return o;
  const e = o.find((t) => t.id === r);
  return !e || !ne(e, n) || T !== n && ne(e, T) ? o : (T = n, Ze(
    o.filter((t) => ne(t, T)),
    r
  ).filter((t) => t.id !== r));
}
var Ce = O(function(n) {
  var r = n, { store: e, typeahead: t = !0 } = r, l = D(r, ["store", "typeahead"]);
  const s = Ye();
  e = e || s, q(
    e,
    process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component"
  );
  const u = l.onKeyDownCapture, h = Ie(0), d = W((a) => {
    if (u == null || u(a), a.defaultPrevented || !t || !e) return;
    const { renderedItems: i, items: S, activeId: b } = e.getState();
    if (!qt(a)) return ve();
    let g = Ut(
      i.length ? i : S
    );
    if (!Wt(a, g)) return ve();
    a.preventDefault(), window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      T = "";
    }, 500);
    const C = a.key.toLowerCase();
    T += C, g = Gt(g, C, b);
    const w = g.find((P) => ne(P, T));
    w ? e.move(w.id) : ve();
  });
  return l = E(f({}, l), {
    onKeyDownCapture: d
  }), Se(l);
});
N(function(n) {
  const r = Ce(n);
  return A(Bt, r);
});
var Jt = "button", je = O(function(n) {
  var r = n, { store: e } = r, t = D(r, ["store"]);
  const l = et();
  e = e || l, q(
    e,
    process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component."
  );
  const s = t.onClick, u = W((h) => {
    e == null || e.setAnchorElement(h.currentTarget), s == null || s(h);
  });
  return t = G(
    t,
    (h) => /* @__PURE__ */ c(Ae, { value: e, children: h }),
    [e]
  ), t = E(f({}, t), {
    onClick: u
  }), t = tt(f({ store: e }, t)), t = Xe(f({ store: e }, t)), t;
});
N(function(n) {
  const r = je(n);
  return A(Jt, r);
});
var J = bt(
  [rt, nt],
  [Ae, ot]
), ae = J.useContext, Qt = J.useScopedContext, ie = J.useProviderContext, Xt = J.ContextProvider, Me = J.ScopedContextProvider, Re = se(!1), Ee = se(null);
function Yt(o = {}) {
  var n = o, {
    combobox: r
  } = n, e = gt(n, [
    "combobox"
  ]);
  const t = Ot(
    e.store,
    Dt(r, [
      "value",
      "items",
      "renderedItems",
      "baseElement",
      "arrowElement",
      "anchorElement",
      "contentElement",
      "popoverElement",
      "disclosureElement"
    ])
  );
  Nt(e, t);
  const l = t.getState(), s = lt(ee(R({}, e), {
    store: t,
    virtualFocus: I(
      e.virtualFocus,
      l.virtualFocus,
      !0
    ),
    includesBaseElement: I(
      e.includesBaseElement,
      l.includesBaseElement,
      !1
    ),
    activeId: I(
      e.activeId,
      l.activeId,
      e.defaultActiveId,
      null
    ),
    orientation: I(
      e.orientation,
      l.orientation,
      "vertical"
    )
  })), u = st(ee(R({}, e), {
    store: t,
    placement: I(
      e.placement,
      l.placement,
      "bottom-start"
    )
  })), h = new String(""), d = ee(R(R({}, s.getState()), u.getState()), {
    value: I(
      e.value,
      l.value,
      e.defaultValue,
      h
    ),
    setValueOnMove: I(
      e.setValueOnMove,
      l.setValueOnMove,
      !1
    ),
    labelElement: I(l.labelElement, null),
    selectElement: I(l.selectElement, null),
    listElement: I(l.listElement, null)
  }), a = Vt(d, s, u, t);
  return te(
    a,
    () => pe(a, ["value", "items"], (i) => {
      if (i.value !== h || !i.items.length) return;
      const S = i.items.find(
        (b) => !b.disabled && b.value != null
      );
      (S == null ? void 0 : S.value) != null && a.setState("value", S.value);
    })
  ), te(
    a,
    () => pe(a, ["mounted"], (i) => {
      i.mounted || a.setState("activeId", d.activeId);
    })
  ), te(
    a,
    () => pe(a, ["mounted", "items", "value"], (i) => {
      if (r || i.mounted) return;
      const S = Ve(i.value), b = S[S.length - 1];
      if (b == null) return;
      const g = i.items.find(
        (C) => !C.disabled && C.value === b
      );
      g && a.setState("activeId", g.id);
    })
  ), te(
    a,
    () => At(a, ["setValueOnMove", "moves"], (i) => {
      const { mounted: S, value: b, activeId: g } = a.getState();
      if (!i.setValueOnMove && S || Array.isArray(b) || !i.moves || !g) return;
      const C = s.item(g);
      !C || C.disabled || C.value == null || a.setState("value", C.value);
    })
  ), ee(R(R(R({}, s), u), a), {
    combobox: r,
    setValue: (i) => a.setState("value", i),
    setLabelElement: (i) => a.setState("labelElement", i),
    setSelectElement: (i) => a.setState("selectElement", i),
    setListElement: (i) => a.setState("listElement", i)
  });
}
function Zt(o, n, r) {
  return Ct(n, [r.combobox]), _e(o, r, "value", "setValue"), _e(o, r, "setValueOnMove"), Object.assign(
    it(
      ct(o, n, r),
      n,
      r
    ),
    { combobox: r.combobox }
  );
}
function eo(o = {}) {
  const n = at();
  o = E(f({}, o), {
    combobox: o.combobox !== void 0 ? o.combobox : n
  });
  const [r, e] = Tt(Yt, o);
  return Zt(r, e, o);
}
var to = "span", oo = O(
  function(n) {
    var r = n, { store: e } = r, t = D(r, ["store"]);
    const l = ae();
    return e = e || l, t = ut(f({ store: e }, t)), t;
  }
), ze = N(function(n) {
  const r = oo(n);
  return A(to, r);
}), ro = "button";
function no(o) {
  return Array.from(o.selectedOptions).map((n) => n.value);
}
function oe(o, n) {
  return () => {
    const r = n();
    if (!r) return;
    let e = 0, t = o.item(r);
    const l = t;
    for (; t && t.value == null; ) {
      const s = n(++e);
      if (!s) return;
      if (t = o.item(s), t === l) break;
    }
    return t == null ? void 0 : t.id;
  };
}
var lo = O(function(n) {
  var r = n, {
    store: e,
    name: t,
    form: l,
    required: s,
    showOnKeyDown: u = !0,
    moveOnKeyDown: h = !0,
    toggleOnPress: d = !0,
    toggleOnClick: a = d
  } = r, i = D(r, [
    "store",
    "name",
    "form",
    "required",
    "showOnKeyDown",
    "moveOnKeyDown",
    "toggleOnPress",
    "toggleOnClick"
  ]);
  const S = ie();
  e = e || S, q(
    e,
    process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component."
  );
  const b = i.onKeyDown, g = z(u), C = z(h), P = e.useState("placement").split("-")[0], k = e.useState("value"), j = Array.isArray(k), U = W((p) => {
    var v;
    if (b == null || b(p), p.defaultPrevented || !e) return;
    const { orientation: ue, items: de, activeId: X } = e.getState(), Y = ue !== "horizontal", Z = ue !== "vertical", y = !!((v = de.find((Pe) => !Pe.disabled && Pe.value != null)) != null && v.rowId), ye = {
      ArrowUp: (y || Y) && oe(e, e.up),
      ArrowRight: (y || Z) && oe(e, e.next),
      ArrowDown: (y || Y) && oe(e, e.down),
      ArrowLeft: (y || Z) && oe(e, e.previous)
    }[p.key];
    ye && C(p) && (p.preventDefault(), e.move(ye()));
    const we = P === "top" || P === "bottom";
    ({
      ArrowDown: we,
      ArrowUp: we,
      ArrowLeft: P === "left",
      ArrowRight: P === "right"
    })[p.key] && g(p) && (p.preventDefault(), e.move(X), wt(p.currentTarget, "keyup", e.show));
  });
  i = G(
    i,
    (p) => /* @__PURE__ */ c(Me, { value: e, children: p }),
    [e]
  );
  const [L, $] = re(!1), V = Ie(!1);
  fe(() => {
    const p = V.current;
    V.current = !1, !p && $(!1);
  }, [k]);
  const F = e.useState((p) => {
    var v;
    return (v = p.labelElement) == null ? void 0 : v.id;
  }), m = i["aria-label"], x = i["aria-labelledby"] || F, M = e.useState((p) => {
    if (t)
      return p.items;
  }), K = Oe(() => [...new Set(M == null ? void 0 : M.map((p) => p.value).filter((p) => p != null))], [M]);
  i = G(
    i,
    (p) => t ? /* @__PURE__ */ H(xe, { children: [
      /* @__PURE__ */ H(
        "select",
        {
          style: {
            border: 0,
            clip: "rect(0 0 0 0)",
            height: "1px",
            margin: "-1px",
            overflow: "hidden",
            padding: 0,
            position: "absolute",
            whiteSpace: "nowrap",
            width: "1px"
          },
          tabIndex: -1,
          "aria-hidden": !0,
          "aria-label": m,
          "aria-labelledby": x,
          name: t,
          form: l,
          required: s,
          value: k,
          multiple: j,
          onFocus: () => {
            var v;
            return (v = e == null ? void 0 : e.getState().selectElement) == null ? void 0 : v.focus();
          },
          onChange: (v) => {
            V.current = !0, $(!0), e == null || e.setValue(
              j ? no(v.target) : v.target.value
            );
          },
          children: [
            Ve(k).map((v) => v == null || K.includes(v) ? null : /* @__PURE__ */ c("option", { value: v, children: v }, v)),
            K.map((v) => /* @__PURE__ */ c("option", { value: v, children: v }, v))
          ]
        }
      ),
      p
    ] }) : p,
    [
      e,
      m,
      x,
      t,
      l,
      s,
      k,
      j,
      K
    ]
  );
  const Q = /* @__PURE__ */ H(xe, { children: [
    k,
    /* @__PURE__ */ c(ze, {})
  ] }), ce = e.useState("contentElement");
  return i = E(f({
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": F,
    "aria-haspopup": yt(ce, "listbox"),
    "data-autofill": L || void 0,
    "data-name": t,
    children: Q
  }, i), {
    ref: be(e.setSelectElement, i.ref),
    onKeyDown: U
  }), i = je(f({ store: e, toggleOnClick: a }, i)), i = Ce(f({ store: e }, i)), i;
}), $e = N(function(n) {
  const r = lo(n);
  return A(ro, r);
});
function so(o = {}) {
  const n = eo(o);
  return /* @__PURE__ */ c(Xt, { value: n, children: o.children });
}
var ao = "span", io = O(
  function(n) {
    var r = n, { store: e, checked: t } = r, l = D(r, ["store", "checked"]);
    const s = le(Re);
    return t = t ?? s, l = Ke(E(f({}, l), { checked: t })), l;
  }
), co = N(function(n) {
  const r = io(n);
  return A(ao, r);
}), uo = "div";
function mo(o, n) {
  if (n != null)
    return o == null ? !1 : Array.isArray(o) ? o.includes(n) : o === n;
}
var po = O(
  function(n) {
    var r = n, {
      store: e,
      value: t,
      getItem: l,
      hideOnClick: s,
      setValueOnClick: u = t != null,
      preventScrollOnKeyDown: h = !0,
      focusOnHover: d = !0
    } = r, a = D(r, [
      "store",
      "value",
      "getItem",
      "hideOnClick",
      "setValueOnClick",
      "preventScrollOnKeyDown",
      "focusOnHover"
    ]), i;
    const S = Qt();
    e = e || S, q(
      e,
      process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component."
    );
    const b = ge(a.id), g = Pt(a), C = Ge(
      (m) => {
        const x = E(f({}, m), {
          value: g ? void 0 : t,
          children: t
        });
        return l ? l(x) : x;
      },
      [g, t, l]
    ), w = e.useState(
      (m) => Array.isArray(m.value)
    );
    s = s ?? (t != null && !w);
    const P = a.onClick, k = z(u), j = z(s), U = W((m) => {
      P == null || P(m), !m.defaultPrevented && (_t(m) || Et(m) || (k(m) && t != null && (e == null || e.setValue((x) => Array.isArray(x) ? x.includes(t) ? x.filter((M) => M !== t) : [...x, t] : t)), j(m) && (e == null || e.hide())));
    }), L = e.useState((m) => mo(m.value, t));
    a = G(
      a,
      (m) => /* @__PURE__ */ c(Re.Provider, { value: L ?? !1, children: m }),
      [L]
    );
    const $ = e.useState("listElement"), V = e.useState((m) => t == null || m.value == null || m.activeId !== b && (e != null && e.item(m.activeId)) ? !1 : Array.isArray(m.value) ? m.value[m.value.length - 1] === t : m.value === t);
    a = E(f({
      id: b,
      role: xt($),
      "aria-selected": L,
      children: t
    }, a), {
      autoFocus: (i = a.autoFocus) != null ? i : V,
      onClick: U
    }), a = dt(f({
      store: e,
      getItem: C,
      preventScrollOnKeyDown: h
    }, a));
    const F = z(d);
    return a = mt(E(f({
      store: e
    }, a), {
      // We have to disable focusOnHover when the popup is closed, otherwise
      // the active item will change to null (the container) when the popup is
      // closed by clicking on an item.
      focusOnHover(m) {
        if (!F(m)) return !1;
        const x = e == null ? void 0 : e.getState();
        return !!(x != null && x.open);
      }
    })), a;
  }
), vo = Le(
  N(function(n) {
    const r = po(n);
    return A(uo, r);
  })
), fo = "div", ho = O(
  function(n) {
    var r = n, { store: e } = r, t = D(r, ["store"]);
    const l = ie();
    e = e || l, q(
      e,
      process.env.NODE_ENV !== "production" && "SelectLabel must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const s = ge(t.id), u = t.onClick, h = W((d) => {
      u == null || u(d), !d.defaultPrevented && queueMicrotask(() => {
        const a = e == null ? void 0 : e.getState().selectElement;
        a == null || a.focus();
      });
    });
    return t = E(f({
      id: s
    }, t), {
      ref: be(e.setLabelElement, t.ref),
      onClick: h,
      style: f({
        cursor: "default"
      }, t.style)
    }), Se(t);
  }
), So = Le(
  N(function(n) {
    const r = ho(n);
    return A(fo, r);
  })
), bo = "div", ke = se(null), Fe = O(
  function(n) {
    var r = n, {
      store: e,
      resetOnEscape: t = !0,
      hideOnEnter: l = !0,
      focusOnMove: s = !0,
      composite: u,
      alwaysVisible: h
    } = r, d = D(r, [
      "store",
      "resetOnEscape",
      "hideOnEnter",
      "focusOnMove",
      "composite",
      "alwaysVisible"
    ]);
    const a = ae();
    e = e || a, q(
      e,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const i = ge(d.id), S = e.useState("value"), b = Array.isArray(S), [g, C] = re(S), w = e.useState("mounted");
    fe(() => {
      w || C(S);
    }, [w, S]), t = t && !b;
    const P = d.onKeyDown, k = z(t), j = z(l), U = W((y) => {
      P == null || P(y), !y.defaultPrevented && (y.key === "Escape" && k(y) && (e == null || e.setValue(g)), (y.key === " " || y.key === "Enter") && Te(y) && j(y) && (y.preventDefault(), e == null || e.hide()));
    }), L = le(Ee), $ = re(), [V, F] = L || $, m = Oe(
      () => [V, F],
      [V]
    ), [x, M] = re(null), K = le(ke);
    fe(() => {
      if (K)
        return K(e), () => K(null);
    }, [K, e]), d = G(
      d,
      (y) => /* @__PURE__ */ c(Me, { value: e, children: /* @__PURE__ */ c(ke.Provider, { value: M, children: /* @__PURE__ */ c(Ee.Provider, { value: m, children: y }) }) }),
      [e, m]
    );
    const Q = !!e.combobox;
    u = u ?? (!Q && x !== e);
    const [ce, p] = kt(
      u ? e.setListElement : null
    ), v = It(ce, "role", d.role), de = (u || (v === "listbox" || v === "menu" || v === "tree" || v === "grid")) && b || void 0, X = Lt(w, d.hidden, h), Y = X ? E(f({}, d.style), { display: "none" }) : d.style;
    u && (d = f({
      role: "listbox",
      "aria-multiselectable": de
    }, d));
    const Z = e.useState(
      (y) => {
        var me;
        return V || ((me = y.labelElement) == null ? void 0 : me.id);
      }
    );
    return d = E(f({
      id: i,
      "aria-labelledby": Z,
      hidden: X
    }, d), {
      ref: be(p, d.ref),
      style: Y,
      onKeyDown: U
    }), d = pt(E(f({ store: e }, d), { composite: u })), d = Ce(f({ store: e, typeahead: !Q }, d)), d;
  }
);
N(function(n) {
  const r = Fe(n);
  return A(bo, r);
});
var go = "div", Co = O(
  function(n) {
    var r = n, { store: e, alwaysVisible: t } = r, l = D(r, ["store", "alwaysVisible"]);
    const s = ie();
    return e = e || s, l = Fe(f({ store: e, alwaysVisible: t }, l)), l = vt(f({ store: e, alwaysVisible: t }, l)), l;
  }
), yo = Kt(
  N(function(n) {
    const r = Co(n);
    return A(go, r);
  }),
  ie
);
function He({
  store: o,
  fallback: n,
  children: r
} = {}) {
  const e = ae();
  o = o || e;
  const t = jt(o, (l) => (l == null ? void 0 : l.value) || n);
  return r ? r(t || "") : t;
}
const wo = "_select_5zojr_3", Po = "_input_5zojr_10", xo = "_icon_5zojr_13", _o = "_disabled_5zojr_25", Eo = "_button_5zojr_25", ko = "_value_5zojr_31", Io = "_popover_5zojr_44", Oo = "_placeholder_5zojr_50", Do = "_values_5zojr_56", _ = {
  select: wo,
  input: Po,
  icon: xo,
  disabled: _o,
  button: Eo,
  "bottom-border": "_bottom-border_5zojr_28",
  value: ko,
  "select-item": "_select-item_5zojr_34",
  popover: Io,
  placeholder: Oo,
  values: Do
}, Be = B.forwardRef(({ disabled: o, itemsRecord: n, ...r }, e) => /* @__PURE__ */ c(
  $e,
  {
    className: _.input,
    ref: e,
    disabled: o,
    ...r,
    children: /* @__PURE__ */ c(He, { children: (t) => /* @__PURE__ */ c(Ne, { gap: 50, className: _.values, children: Array.isArray(t) && t.map((l, s) => {
      var u, h;
      return /* @__PURE__ */ H(
        "span",
        {
          className: he(_.value, _["select-item"]),
          children: [
            ((u = n[l]) == null ? void 0 : u.label) || ((h = n[l]) == null ? void 0 : h.children) || l || "",
            s < t.length - 1 ? "," : ""
          ]
        },
        l
      );
    }) }) })
  }
));
Be.displayName = "MultipleSelect";
const qe = B.forwardRef(({ value: o, label: n, disabled: r, children: e }, t) => {
  const l = ae(), s = l == null ? void 0 : l.useState(), u = Mt(s == null ? void 0 : s.value) ? s.value.includes(o) : (s == null ? void 0 : s.value) === o;
  return /* @__PURE__ */ c(ft, { selected: u, asChild: !0, children: /* @__PURE__ */ c(
    vo,
    {
      ref: t,
      value: o,
      disabled: r,
      "data-disabled": r,
      focusOnHover: !0,
      children: /* @__PURE__ */ H(Ne, { justifyContent: "space-between", children: [
        /* @__PURE__ */ c("span", { children: n || e || o || "" }),
        /* @__PURE__ */ c(co, { "data-selected": "true", children: /* @__PURE__ */ c(De, { icon: "successful-checkmark" }) })
      ] })
    }
  ) }, o);
});
qe.displayName = "Select.Item";
const We = B.forwardRef(({ disabled: o, itemsRecord: n, ...r }, e) => {
  const t = B.useCallback(
    (l) => {
      const s = n[l];
      return s && ((s == null ? void 0 : s.label) || (s == null ? void 0 : s.children) || (s == null ? void 0 : s.value)) || "";
    },
    [n]
  );
  return /* @__PURE__ */ c(
    $e,
    {
      className: _.input,
      ref: e,
      disabled: o,
      ...r,
      children: /* @__PURE__ */ c(He, { children: (l) => /* @__PURE__ */ c("div", { className: he(_.values, _.value), children: /* @__PURE__ */ c("span", { className: _["select-item"], children: typeof l == "string" && t(l) }) }) })
    }
  );
});
We.displayName = "SingleSelect";
const Ue = B.forwardRef(
  ({
    id: o,
    label: n,
    caption: r,
    disabled: e,
    loading: t,
    invalid: l,
    items: s,
    error: u,
    onSelectionChange: h,
    children: d,
    className: a,
    selectType: i = "single",
    ...S
  }, b) => {
    const g = he(
      _.select,
      {
        [_.invalid]: l,
        [_.disabled]: e
      },
      a
    ), C = B.useMemo(
      () => s.reduce(
        (w, P) => (w[P.value] = P, w),
        {}
      ),
      [s]
    );
    return /* @__PURE__ */ H(so, { ...S, setValue: h, children: [
      /* @__PURE__ */ c("div", { className: g, children: /* @__PURE__ */ c(
        Rt,
        {
          id: o,
          label: /* @__PURE__ */ c(So, { children: n }),
          caption: r,
          error: u,
          trailing: t ? /* @__PURE__ */ c(Je, { size: "md" }) : /* @__PURE__ */ c(ze, { children: /* @__PURE__ */ c(De, { icon: "chevron-down", mode: 200, className: _.icon }) }),
          disabled: e,
          invalid: l,
          children: i === "single" ? /* @__PURE__ */ c(
            We,
            {
              itemsRecord: C,
              className: _.input,
              ref: b,
              disabled: e,
              invalid: l,
              ...S
            }
          ) : /* @__PURE__ */ c(
            Be,
            {
              itemsRecord: C,
              className: _.input,
              ref: b,
              disabled: e,
              invalid: l,
              ...S
            }
          )
        }
      ) }),
      /* @__PURE__ */ c(
        yo,
        {
          flip: !1,
          onKeyDown: (w) => w.stopPropagation(),
          onMouseDown: (w) => w.stopPropagation(),
          portal: !0,
          gutter: 8,
          className: _.popover,
          children: /* @__PURE__ */ c(Qe, { children: d(s) })
        }
      )
    ] });
  }
), Go = Object.assign(Ue, {
  Item: qe
});
Ue.displayName = "Select";
export {
  Go as Select
};
//# sourceMappingURL=select.js.map
